import { Image } from "antd";
import { useEffect, useState } from "react";

const InfoCard = ({ hideEdit = true, showImageEdit = false, ...props }) => {
  const PERSONA = props?.$store.persona || {};
  const [connectorinfo, setConnectorinfo] = useState({});
  const [profileStatus, setProfileStatus] = useState("");
  const [userInitials, setUserInitials] = useState("");

  const getInitials = (name) => {
    if (!name) return "";

    const words = name.trim().split(" ");

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
  };

  const getStatus = (statusObj) => {
    return Object.values(statusObj).includes(false) ? "Pending" : "Completed";
  };

  useEffect(() => {
    if (props?.data) {
      console.log(props.data);
      setConnectorinfo(props.data);

      const verificationStatus = {
        isAadharVerified: props?.data?.is_aadhar_verified,
        is_agreement_signed: props?.data?.is_agreement_signed,
        isPanVerified: props?.data?.is_pan_code_verified,
      };
      let status = getStatus(verificationStatus);
      setProfileStatus(status);

      let userInitials = getInitials(props?.data?.full_name);
      console.log({ userInitials });
      setUserInitials(userInitials);
    }
  }, [props?.data]);

  return (
    <div className="info_card">
      <div className="row">
        <div className="col-12 col-md-2">
          <div className="avatar_card">
            <div className="img_outer">
              {showImageEdit && (
                <button
                  className={Object.className({
                    edit_btn: true,
                  })}
                  onClick={(...args) => props.onProfileImageEdit(...args)}
                >
                  <i className="fa fa-pencil"></i>
                </button>
              )}
              {connectorinfo?.profileUrl ? (
                <Image
                  width={200}
                  preview={false}
                  src={connectorinfo?.profileUrl}
                />
              ) : (
                <div className="initial_box">
                  <h2>{userInitials}</h2>
                </div>
              )}
            </div>
            <h4 className="title text-white mb-1">
              {connectorinfo?.full_name || "-"}
            </h4>
            <p>CONNECTOR</p>
          </div>
        </div>
        <div className="col-12 col-md-10">
          <div className="content">
            <ul className="content_ul">
              <li>
                <span className="li_label">Connector ID</span>
                <span className="li_value">
                  {connectorinfo?.connector_id || "-"}
                </span>
              </li>
              <li>
                <span className="li_label">Mobile No</span>
                <span className="li_value">
                  {connectorinfo?.mobile_number || "-"}
                </span>
              </li>
              <li>
                <span className="li_label">Email ID</span>
                <span className="li_value">
                  {connectorinfo?.email_address || "-"}
                </span>
              </li>
            </ul>

            <ul className="content_ul">
              <li>
                <span className="li_label">Profile Status</span>
                <span className="li_value">{profileStatus || "-"}</span>
              </li>
              <li>
                <span className="li_label">Work Location</span>
                <span className="li_value">
                  {/* {connectorinfo?.city ? `${connectorinfo?.city}, ` : ""}
                  {connectorinfo?.state ? connectorinfo?.state : ""} */}
                  {connectorinfo?.connector_location_name || "-"}
                </span>
              </li>
            </ul>

            {hideEdit && (
              <button
                className={Object.className({
                  edit_btn: true,
                  // "d-none": props.$store?.user?.isAadharVerified,
                })}
                onClick={(...args) => props.onEdit(...args)}
              >
                <i className="fa fa-pencil"></i>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default constore(InfoCard);
